import { useTranslation } from 'react-i18next';
import { FlipVertical2 } from 'lucide-react';

interface FlipBoardButtonProps {
  onClick: () => void;
}

/**
 * «Gira la damiera», un bottone della barra comandi.
 *
 * Esiste come componente perche' lo mostrano due schermate diverse e per due
 * ragioni diverse — la partita in presenza (dove il turno passa di mano allo
 * stesso tavolo) lo infila nel `focusSlot`, e chi guarda una partita lo riceve
 * da `GameToolbar` in `readOnly` — e il bottone deve restare LO STESSO: etichetta,
 * icona, classe e `data-testid`. Prima stava scritto a mano in LocalGame, e
 * duplicarlo li' accanto avrebbe significato due bottoni liberi di divergere.
 */
export function FlipBoardButton({ onClick }: FlipBoardButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="game-toolbar__btn game-toolbar__btn--flip"
      data-testid="toolbar-flip"
      onClick={onClick}
      title={t('game.actions.flipBoard')}
    >
      <FlipVertical2 size={20} aria-hidden="true" />
      <span>{t('game.actions.flipBoard')}</span>
    </button>
  );
}

export default FlipBoardButton;
